<template>
    <div class="policy">
        <h2><strong>개인정보 처리방침</strong></h2>

        <p>최종 업데이트: 2026년 10월 9일</p>

        <h3><strong>개인정보 처리방침 개요</strong></h3>

        <p>당사의 서비스에 오신 것을 환영합니다. 본 서비스는 AKUVOX (SINGAPORE) INNOVATION PTE. LTD.(이하 “AKUVOX (SINGAPORE) INNOVATION”, “당사” 또는 “우리”)가 제공하고 관리합니다. 서비스를 이용함으로써 귀하는 본 개인정보 처리방침에 동의합니다.</p>

        <p>서비스에는 다음이 포함됩니다.</p>

        <ul class="policy-ul">
            <li>*cloud.akuvox.com에서 액세스할 수 있는 당사 웹사이트 및 사용자 계정(*cloud에는 ecloud, ucloud, jcloud, scloud 등이 포함됨)과 이에 연결된 모든 관련 웹사이트(제3자 웹사이트 제외, 이하 “포털”);</li>
            <li>웹사이트를 통해 액세스할 수 있는 온라인 서비스(“웹 서비스”);</li>
            <li>모바일 기기에 다운로드할 수 있는 소프트웨어 애플리케이션(“모바일 앱”), 예: Akuvox SmartPlus, AK-Partner 등;</li>
            <li>서비스와 관련된 제품(“기기”), 예를 들어 도어 인터콤, 실내 모니터, Android 비디오폰, 출입 통제 단말기, 홈 컨트롤 패널 등;</li>
            <li>웹사이트 및 모바일 앱에서 이용할 수 있는 모든 서비스(“이용 가능 서비스”).</li>
            <li>“서비스”란 웹사이트, 웹 서비스, 모바일 앱, 기기 및 이용 가능 서비스를 의미합니다.</li>
        </ul>

        <p>본 개인정보 처리방침은 당사가 누구인지, 귀하에 관하여 어떤 정보를 수집하는지, 귀하의 개인정보를 어떻게 이용하고 공개하는지, 귀하의 정보를 어떻게 보호하는지, 그리고 귀하가 어떠한 개인정보 보호 권리를 가지는지를 설명합니다. 당사의 서비스는 귀하의 개인정보를 매우 중요하게 다루며 귀하가 자신의 개인정보를 통제할 수 있도록 합니다. 당사는 귀하의 개인정보와 프라이버시를 보호하기 위해 강력한 암호화 기술을 사용하고 모든 데이터를 엄격한 정책에 따라 관리합니다. 당사는 귀하와 관련된 개인정보를 일반개인정보보호법(“GDPR”), 캘리포니아 소비자 개인정보 보호법(“CCPA”), 버지니아 소비자 데이터 보호법(“VCDPA”) 및 브라질 일반 데이터 보호법(“LGPD”)에 따라 항상 보호합니다.</p>

        <h3><strong>A. 당사에 대하여</strong></h3>

        <p>서비스는 세금 식별번호 202538798R, 등록 주소 6 RAFFLES QUAY #14-02, Singapore (048580)의 AKUVOX (SINGAPORE) INNOVATION PTE. LTD.가 제공하고 관리합니다.</p>

        <h3><strong>B. 당사가 수집하는 개인정보</strong></h3>

        <p>당사의 서비스는 관련 법률에 따라 서비스를 제공하기 위한 목적으로 개인정보를 수집합니다.</p>

        <p>“개인정보”는 “personal data”와 동일한 의미를 가지며, 식별되었거나 식별 가능한 자연인(“정보주체”)과 관련된 모든 정보를 의미합니다. 식별 가능한 사람은 식별번호 또는 그 사람의 신체적, 생리적, 정신적, 경제적, 문화적 또는 사회적 정체성에 특유한 하나 이상의 요소를 참조하여 직접 또는 간접적으로 식별될 수 있는 사람을 의미합니다.</p>

        <p>당사는 서비스를 제공하기 위해 필요한 개인정보의 제공을 요청합니다. 귀하가 이러한 정보의 일부 또는 전부를 제공하지 않는 경우 당사는 해당 정보를 처리하지 않지만, 서비스 또는 일부 기능의 이용이 제한될 수 있습니다.</p>

        <p>아래에서는 귀하가 당사의 서비스를 이용할 때 당사가 수집하는 정보의 유형을 설명합니다.</p>

        <p><strong>1. 사용자 계정 등록</strong></p>

        <p>서비스 계정을 생성하려면 등록 절차 중 다음 개인정보를 제공해야 합니다.</p>

        <p>Property Manager 계정:</p>

        <ul class="policy-ul">
            <li>이름</li>
            <li>성</li>
            <li>이메일 주소</li>
        </ul>

        <p>최종 사용자 계정:</p>

        <ul class="policy-ul">
            <li>이름</li>
            <li>성</li>
            <li>이메일 주소</li>
            <li>휴대전화 번호</li>
            <li>주소(주거용 사용자인 경우 주거지 주소를 수집하고, 업무용 사용자인 경우 사업장 주소를 수집합니다).</li>
        </ul>

        <p><strong>2. 서비스 이용</strong></p>

        <p>귀하가 당사의 서비스를 이용하는 동안 당사는 아래 개인정보의 전부 또는 일부를 수집합니다.</p>

        <ul class="policy-ul">
            <li>영상 통화, 얼굴 인식 및 QR 코드 로그인 기능 제공을 위해 카메라 권한에 접근해야 합니다.</li>
            <li>음성 및 영상 통화를 지원하기 위해 오디오 녹음 권한에 접근해야 합니다.</li>
            <li>유선 전화 서비스를 지원하기 위해 연락처 정보에 대한 접근 및 수정 권한이 필요합니다.</li>
            <li>휴대전화 번호 로그인을 지원하기 위해 휴대전화 번호 정보에 접근해야 합니다.</li>
            <li>로그 내보내기, 얼굴 이미지 업로드 및 QR 코드 로그인을 지원하기 위해 외부 저장소 읽기 권한에 접근해야 합니다.</li>
            <li>로그 내보내기를 지원하기 위해 외부 저장소 쓰기 권한에 접근해야 합니다.</li>
            <li>푸시 알림 제공을 위해 알림 권한에 접근해야 합니다.</li>
            <li>착신전환 서비스 제공을 위해 전화 권한에 접근해야 합니다.</li>
            <li>최종 사용자 서비스의 호환성을 보장하기 위해 시스템 운영 정보에 접근해야 합니다.</li>
            <li>네트워크 선택 및 성능 최적화를 위해 네트워크 상태 정보에 접근해야 합니다.</li>
            <li>오프라인 상태에서 전화를 수신할 수 있도록 자동 시작 서비스를 사용해야 합니다.</li>
            <li>Bluetooth를 통한 출입 기능 제공을 위해 Bluetooth 권한, 정확한 위치 권한, 센서 데이터 수집 및 자동 시작 서비스가 필요합니다.</li>
            <li>최종 사용자 기기를 고유하게 식별하기 위해 MAC 주소, International Mobile Equipment Identity(IMEI), Anonymous Device Identifier(OAID), International Mobile Subscriber Identity(IMSI)를 수집합니다.</li>
            <li>ID를 감지·동기화하고 연결 관계를 통합하기 위해 앱 목록 정보에 접근해야 합니다.</li>
            <li>오디오 및 비디오 기능이 정상적으로 작동하도록 제품 최초 사용 시 플로팅 윈도우 권한에 접근해야 합니다.</li>
            <li>Tiandy NVR의 모니터링 및 재생 기능을 지원하기 위해 Alibaba Cloud, Alibaba Push, mPaaS, Alibaba Long Connection Channel 및 Alibaba Baichuan E-commerce SDK를 통합합니다. 이러한 구성요소는 백그라운드 실행 또는 일정 간격의 무음 데이터 수집이 필요할 수 있으며, IP 주소 및 GAID를 포함한 광고 ID 권한에 대한 접근을 요청할 수 있습니다.</li>
        </ul>

        <p><strong>3. 문제 해결 및 서비스 개선</strong></p>

        <p>귀하가 서비스를 이용하면서 겪는 문제를 해결하고 당사의 서비스를 최적화하기 위해 모바일 앱 사용 중 다음 정보를 수집합니다.</p>

        <ul class="policy-ul">
            <li>최근 로그인</li>
            <li>이용 시간</li>
            <li>음성 및 영상 통화</li>
            <li>시스템 로그</li>
            <li>설치된 애플리케이션 데이터</li>
            <li>연락처 이름 등 개인정보를 포함할 수 있는 다운로드된 구성 정보</li>
        </ul>

        <p><strong>4. 서비스 구독</strong></p>

        <p>귀하가 서비스에 대한 결제를 선택한 경우 다음 개인정보가 당사에 제공됩니다.</p>

        <ul class="policy-ul">
            <li>이름</li>
            <li>성</li>
            <li>이메일 주소</li>
            <li>거주 국가</li>
            <li>결제 정보</li>
        </ul>

        <p>이러한 개인정보의 처리는 서비스를 제공하기 위해 필요하며, 귀하와 체결한 계약의 이행을 위해 필요합니다.</p>

        <p><strong>5. 제3자 서비스</strong></p>

        <p>귀하가 당사의 서비스를 통해 제3자 서비스를 이용하는 경우, 당사는 귀하의 요청에 응답하고 요청한 서비스를 제공하며 당사의 서비스를 개선하기 위해 개인정보를 처리합니다. 서비스 제공 및 맞춤형 콘텐츠 제공을 위해 당사는 제3자 서비스 제공자와의 계약에 따라 사용자 식별 및 관리를 위한 개인정보를 제공받을 수 있습니다.</p>

        <p>제3자 서비스 이용에는 해당 제3자의 이용약관 또는 서비스 약관 및 각 개인정보 보호 고지가 적용된다는 점에 유의하시기 바랍니다. 기기에서 이러한 서비스를 활성화하기 전에 해당 조건을 주의 깊게 읽어보시기 바랍니다. 당사의 개인정보 처리는 귀하와의 계약 이행 및 당사의 정당한 이익을 위해 필요합니다.</p>

        <p>당사는 제3자 서비스로부터 귀하에 관한 정보를 수집할 수도 있습니다. 이러한 개인정보의 처리는 서비스를 제공하기 위해 필요하므로 귀하와의 계약 이행을 위해 필요합니다.</p>

        <p>중요: 귀하는 언제든지 이러한 데이터 수집에 반대할 수 있습니다. 이 경우 당사는 해당 목적을 위한 개인정보 수집을 즉시 중단합니다.</p>

        <p><strong>6. 민감한 개인정보</strong></p>

        <p>당사가 수집하는 일부 데이터는 민감한 개인정보로 간주될 수 있습니다. 여기에는 생체정보(예: 출입 통제를 위한 얼굴 인식 이미지 및 손바닥 정맥 데이터), 정확한 위치 정보, 연락처 및 고유 기기 식별자(IMEI, IMSI)가 포함됩니다. 당사는 귀하의 명시적인 동의를 받은 경우에만, 그리고 요청한 서비스 기능을 제공하기 위한 목적으로만 이러한 데이터를 수집하고 처리합니다. 당사는 암호화, 접근 통제, 제한된 보유기간을 포함한 엄격한 보안 조치를 적용하여 이러한 민감한 개인정보를 보호합니다.</p>

        <h3><strong>C. 쿠키 및 유사 기술</strong></h3>

        <p>쿠키 및 유사 기술은 인터넷에서 일반적으로 사용됩니다. 쿠키는 웹사이트를 방문할 때 컴퓨터로 전송되는 문자열이 포함된 작은 파일입니다. 웹사이트를 다시 방문하면 쿠키를 통해 웹사이트가 귀하의 브라우저를 인식할 수 있습니다. 쿠키는 사용자 환경설정 및 기타 정보도 저장할 수 있습니다. 브라우저를 설정하여 모든 쿠키를 거부하거나 웹사이트가 컴퓨터로 쿠키를 전송할 때 알림을 받도록 할 수 있습니다. 다만 쿠키가 없으면 웹사이트의 일부 기능이나 서비스가 정상적으로 작동하지 않을 수 있습니다.</p>

        <p>귀하가 웹사이트 및 모바일 앱에 접근하고 이용할 때 당사는 이러한 기술을 사용하여 귀하의 기기에 쿠키 또는 익명 식별자를 전송하고 정보를 수집 및 저장할 수 있습니다. 현지 법률이 인터넷 프로토콜(IP) 주소 또는 유사한 식별자를 개인정보로 간주하는 경우를 제외하고, 당사는 쿠키 및 기타 기술을 통해 수집된 정보를 비개인정보로 취급합니다. 당사는 쿠키 및 유사 기술을 다음 목적으로 사용합니다.</p>

        <p><strong>1. 서비스의 안전하고 효율적인 운영 보장</strong></p>

        <p>당사는 귀하가 서비스에 안전하게 로그인했는지 확인하거나 사기와 같은 불법 행위가 발생했는지 평가하기 위해 인증 또는 보안 쿠키나 익명 식별자를 설정할 수 있습니다. 이러한 기술은 서비스 효율성, 시스템 로그인 속도 및 응답 속도를 향상하는 데에도 도움이 됩니다.</p>

        <p><strong>2. 접근 편의성 제공</strong></p>

        <p>이러한 기술을 사용하면 원클릭 로그인 및 검색 기록 등을 통해 개인정보 또는 검색 내용을 반복해서 입력하는 절차를 줄일 수 있습니다.</p>

        <p><strong>3. 로그 파일</strong></p>

        <p>대부분의 웹사이트와 마찬가지로 당사는 특정 정보를 수집하여 로그 파일에 저장합니다. 이러한 정보에는 인터넷 프로토콜(IP) 주소, 브라우저 유형, 인터넷 서비스 제공업체(ISP), 참조/종료 페이지, 운영체제, 날짜/시간 스탬프 및/또는 클릭스트림 데이터가 포함될 수 있습니다. 당사는 자동으로 수집된 로그 데이터를 다른 수집 정보와 연결하지 않습니다.</p>

        <p><strong>4. 모바일 분석</strong></p>

        <p>웹사이트 및 모바일 앱과 관련하여 당사는 모바일 분석 소프트웨어를 사용하여 휴대전화에서 당사 모바일 소프트웨어가 어떻게 작동하는지 더 잘 이해합니다. 이 소프트웨어는 애플리케이션 사용 빈도, 애플리케이션 내 이벤트, 누적 사용량, 성능 데이터 및 애플리케이션 충돌 지점에 관한 데이터를 기록할 수 있습니다. 당사는 분석 소프트웨어에 저장된 정보를 귀하가 웹사이트 또는 모바일 앱에서 제출한 개인정보와 연결하지 않습니다.</p>

        <h3><strong>D. 당사가 개인정보를 이용하는 방법</strong></h3>

        <p>당사는 수집한 개인정보를 다음 목적으로 이용할 수 있습니다.</p>

        <p>1. 서비스 제공. 방문자가 인터콤을 통해 귀하에게 전화할 수 있도록 하는 등 서비스 이용을 가능하게 하기 위해 귀하의 개인정보를 *cloud.akuvox.com(*cloud에는 ecloud, ucloud, jcloud, scloud 등이 포함됨)과 공유합니다.</p>

        <p>2. 문제 해결 및 유지보수. 귀하의 애플리케이션 문제를 분석 및 진단하고 서비스 이용 경험을 개선하기 위해 사용자의 설치 애플리케이션 데이터를 https://maintenance.akuvox.com 에 업로드합니다.</p>

        <p>3. 서비스 설문조사, 문의 응답 및 신규 서비스 홍보 등 마케팅 목적으로 귀하의 개인정보를 사용하여 연락할 수 있습니다.</p>

        <p>4. 서비스 개선을 위한 데이터 분석, 연구 및 웹사이트와 모바일 앱 이용에 관한 통계 정보 개발 등 내부 목적으로 이용할 수 있습니다.</p>

        <p>5. 서비스의 공유 기능을 개선하기 위해 귀하의 기기에 설치된 애플리케이션에 관한 정보를 수집할 수 있습니다. 이 정보는 해당 애플리케이션을 통한 콘텐츠 공유를 가능하게 하고 보다 편리한 공유 옵션을 제공하기 위한 목적으로만 사용됩니다.</p>

        <p>6. 소프트웨어 검증 및 서비스 업그레이드를 수행합니다.</p>

        <p>7. 법률 준수 및 권리 행사. 당사는 관련 법률의 준수 여부를 평가·보장하고, 당사의 자산을 보호하며, 위법 또는 부정행위에 관한 주장을 조사하거나 이에 대응하고, 법률 자문을 받거나 법적 청구를 설정·행사·방어하며, 법원 명령, 법원 또는 기타 정부 기관의 소환장 또는 수색영장에 대응하기 위해 합리적으로 필요한 범위에서 귀하의 개인정보를 사용할 수 있습니다.</p>

        <h3><strong>E. 당사가 개인정보를 공개하는 방법</strong></h3>

        <p>당사는 어떠한 목적으로도 개인정보를 판매하지 않습니다. 다음 범주의 수령인에게 귀하의 개인정보를 공개할 수 있습니다.</p>

        <p><strong>1. 서비스 제공업체</strong></p>

        <p>당사는 현지 시장에서 당사의 사업 운영을 지원하는 서비스를 제공하는 제3자 서비스 제공업체에 귀하의 정보를 공개할 수 있습니다. 여기에는 임대인, Property Manager 및 현지 비즈니스 파트너가 포함될 수 있습니다. 귀하는 이러한 제3자 공개에 관한 정보를 요청하고 특정 공개에 반대할 권리가 있습니다.</p>

        <p><strong>2. 법 집행 기관</strong></p>

        <p>당사는 법률상 요구되거나 법적 의무, 절차 또는 요청을 준수하기 위해 합리적으로 필요한 경우 법 집행 기관, 공공기관 또는 기타 조직과 귀하의 정보를 공유합니다. 데이터 전송 중에는 귀하의 정보 보안을 위해 데이터를 암호화합니다. 법률이 요구하는 경우 귀하는 이러한 공개에 대해 통지받을 권리가 있습니다.</p>

        <p><strong>3. 정보 공유 사실을 알 권리(CCPA 요구사항)</strong></p>

        <p>캘리포니아 거주 사용자는 자신의 개인정보가 제3자와 공유되는지 여부 및 그 수령인의 범주를 알 권리가 있습니다. 당사는 엄격한 사업 목적을 위해서만 서비스 제공업체(예: 클라우드 호스팅, 푸시 알림 또는 분석 서비스 제공업체)와 귀하의 개인정보를 공유합니다. 당사는 귀하의 개인정보를 제3자에게 판매하지 않습니다.</p>

        <h3><strong>F. 개인정보의 저장 및 전송</strong></h3>

        <p>서비스 인프라는 미국 북부 캘리포니아, 독일 프랑크푸르트, 싱가포르 등 여러 지역의 웹 서비스에서 운영되며, 귀하의 개인정보는 해당 서버에 저장됩니다. 귀하의 개인정보는 서버에서 Amazon Cloud 또는 Alibaba Cloud로 백업됩니다. 데이터 전송 중에는 안전을 보장하기 위해 데이터를 암호화하고 보호합니다.</p>

        <p>본 개인정보 처리방침에 설명된 목적을 위해 이러한 정보를 처리하는 경우, 요청한 서비스를 제공하기 위해 귀하의 정보 중 특정 부분에 접근할 수 있습니다. 당사의 콘텐츠 데이터 관리에 관한 내부 규정은 모든 데이터 전송이 관련 현지 법률 및 규정을 준수하도록 합니다.</p>

        <h3><strong>G. 귀하의 권리 및 선택</strong></h3>

        <p>서비스를 이용하는 동안 귀하는 개인정보와 관련하여 다음과 같은 권리를 가집니다.</p>

        <p><strong>접근권</strong></p>

        <p>귀하는 자신의 개인정보가 처리되고 있는지 여부에 대한 확인을 받을 권리가 있습니다. 당사가 귀하의 정보를 처리하는 경우 귀하는 해당 개인정보 및 다음 정보에 접근할 권리가 있습니다.</p>

        <p>a) 처리 목적;</p>

        <p>b) 관련 개인정보의 범주;</p>

        <p>c) 개인정보가 공개되었거나 공개될 수령인 또는 수령인 범주, 특히 제3국 또는 국제기구의 수령인;</p>

        <p>d) 가능한 경우 개인정보의 예정 보관기간 또는 불가능한 경우 그 기간을 정하는 기준;</p>

        <p>e) 귀하와 관련된 개인정보의 정정 또는 삭제, 처리 제한을 요구하거나 처리에 반대할 권리의 존재;</p>

        <p>f) 감독기관에 불만을 제기할 권리;</p>

        <p>g) 개인정보가 귀하로부터 수집되지 않은 경우 그 출처에 관한 이용 가능한 모든 정보;</p>

        <p>h) GDPR 제22조 제1항 및 제4항에 따른 프로파일링을 포함한 자동화된 의사결정의 존재와, 적어도 그러한 경우 사용된 논리에 관한 유의미한 정보 및 그러한 처리가 귀하에게 미치는 중요성과 예상 결과.</p>

        <p>개인정보가 제3국 또는 국제기구로 이전되는 경우 귀하는 해당 이전과 관련한 적절한 보호조치에 대해 통지받을 권리가 있습니다.</p>

        <p><strong>정정권</strong></p>

        <p>귀하는 귀하에 관한 부정확한 개인정보를 부당한 지체 없이 정정하도록 당사에 요구할 권리가 있습니다. 처리 목적을 고려하여, 추가 진술 제공을 포함해 불완전한 개인정보를 완전하게 할 권리도 있습니다.</p>

        <p><strong>삭제권(“잊힐 권리”)</strong></p>

        <p>다음 조건 중 하나 이상에 해당하는 경우 귀하는 귀하에 관한 개인정보를 부당한 지체 없이 삭제하도록 당사에 요구할 권리가 있습니다.</p>

        <p>a) 개인정보가 수집 또는 기타 방식으로 처리된 목적에 더 이상 필요하지 않은 경우;</p>

        <p>b) 개인정보가 귀하의 동의를 근거로 처리되었고 귀하가 동의를 철회했으며, 당사에 처리를 계속할 다른 법적 근거가 없는 경우;</p>

        <p>c) 귀하가 처리에 반대하고 처리를 계속할 우선하는 정당한 근거가 없는 경우;</p>

        <p>d) 개인정보가 불법적으로 처리된 경우;</p>

        <p>e) 당사가 준수해야 하는 법적 의무를 이행하기 위해 개인정보를 삭제해야 하는 경우.</p>

        <p>귀하가 개인정보 삭제를 원하지만 위 조건이 적용되는지 또는 제한이 있는지 확신하지 못하는 경우 당사에 연락할 수 있으며, 당사는 귀하의 요청을 가능한 최선의 방식으로 처리하도록 지원합니다.</p>

        <p><strong>처리 제한권</strong></p>

        <p>다음 중 하나에 해당하는 경우 귀하는 처리 제한을 요구할 권리가 있습니다.</p>

        <p>a) 개인정보의 정확성에 이의를 제기한 경우;</p>

        <p>b) 처리가 불법이지만 귀하가 개인정보 삭제에 반대하고 대신 이용 제한을 요구하는 경우;</p>

        <p>c) 당사가 처리 목적상 더 이상 개인정보를 필요로 하지 않지만 귀하가 법적 청구의 설정, 행사 또는 방어를 위해 해당 개인정보를 필요로 하는 경우;</p>

        <p>d) 귀하가 처리에 반대했으며 당사의 정당한 사유가 귀하의 사유보다 우선하는지 확인 중인 경우.</p>

        <p>처리가 제한된 경우, 저장을 제외하고 해당 개인정보는 귀하의 동의가 있거나 법적 청구의 설정·행사·방어 또는 다른 자연인이나 법인의 권리 보호를 위해서만 처리될 수 있습니다.</p>

        <p><strong>데이터 이동권</strong></p>

        <p>귀하는 귀하와 관련된 특정 개인정보를 구조화되고 일반적으로 사용되며 기계 판독 가능한 형식으로 받을 권리와, 방해 없이 다른 개인정보처리자에게 전송할 권리가 있습니다. 이 권리는 다음 개인정보에 적용됩니다.</p>

        <p>a) 귀하로부터 제공받은 개인정보;</p>

        <p>b) 귀하의 동의 또는 계약을 근거로 처리되는 개인정보; 그리고</p>

        <p>c) 자동화된 수단으로 처리되는 개인정보.</p>

        <p>당사가 위 기준을 충족하는 개인정보를 처리하는 경우 기술적으로 가능한 때에는 해당 개인정보를 당사가 다른 개인정보처리자에게 직접 전송하도록 요구할 권리도 있습니다.</p>

        <p><strong>반대권</strong></p>

        <p>귀하는 예를 들어 직접 마케팅 목적을 포함하여 귀하와 관련된 개인정보 처리에 반대할 권리가 있습니다. 당사는 귀하의 각 반대를 신중하게 검토하고, 처리를 계속할 중대한 정당한 사유가 없는 경우 해당 개인정보의 처리를 중단합니다.</p>

        <h3><strong>H. 개인정보의 보안</strong></h3>

        <p>당사의 서비스에는 강력한 보안 기능이 내장되어 있습니다. 당사는 엄격한 정보 관리 정책을 운영하고 전문 기술팀을 두며, 무단 접근, 공개, 오용, 변경, 파기 및 손실로부터 귀하의 개인정보를 보호하기 위해 다음을 포함한 합리적인 예방조치를 취합니다.</p>

        <p>1. 전송 중 데이터의 기밀성을 유지하기 위한 암호화 기술 사용;</p>

        <p>2. 계정 보안을 지원하는 다양한 보안 기능 제공;</p>

        <p>3. 무단 사용자의 시스템 접근을 방지하기 위한 물리적 보안조치를 포함하여 정보 수집, 저장 및 처리 관행을 검토.</p>

        <h3><strong>I. 개인정보 보유기간</strong></h3>

        <p>당사는 수집한 개인정보를 데이터의 성격 및 이용 방식에 따라 서로 다른 기간 동안 보관합니다. 아래에서는 서로 다른 유형의 데이터 세트를 다른 기간 동안 보관하는 이유를 설명합니다.</p>

        <p>1. 수집 목적에 따라 데이터 유형별로 서로 다른 보유기간을 설정합니다. 예를 들어, 문 열림 기록 및 통화 기록은 3개월 후 자동 삭제됩니다.</p>

        <p>2. 사용자 계정 정보 등 귀하의 개인정보는 계정이 삭제될 때까지 보관됩니다.</p>

        <p>3. 제한된 목적을 위해 더 오랜 기간 보관되는 정보가 있습니다. 때로는 사업상, 법률상 또는 규제상 요건으로 인해 특정 정보를 특정 목적을 위해 더 오래 보관해야 할 수 있습니다.</p>

        <h3><strong>J. 아동의 개인정보 보호</strong></h3>

        <p>당사는 만 18세 미만 아동이 당사의 서비스를 이용하거나 접근하는 것을 의도하지 않습니다. 만 18세 미만인 경우 부모 또는 법정대리인의 관여 하에서만 당사의 서비스를 이용할 수 있습니다. 등록 사용자가 만 18세 미만이라는 사실을 실제로 알게 되는 경우 당사는 해당 계정과 관련된 정보를 신속하게 삭제합니다.</p>

        <p>귀하가 부모 또는 보호자이며 귀하의 동의 없이 자녀가 당사에 개인정보를 제공한 사실을 알게 된 경우 support@akuvoxsmartplus.com 으로 연락하여 해당 정보를 당사 시스템에서 삭제하도록 요청해 주시기 바랍니다.</p>

        <h3><strong>K. 본 개인정보 처리방침의 업데이트</strong></h3>

        <p>당사는 본 개인정보 처리방침을 수시로 변경 및 업데이트할 수 있습니다. 개인정보 처리방침의 업데이트는 웹사이트 및 모바일 앱에서 알림 및 기타 방식으로 게시됩니다. 모바일 앱에서 최신 버전의 개인정보 처리방침을 확인할 수 있습니다. 중대한 변경이 있는 경우 정식으로 통지하며, 일부 서비스의 경우 이메일을 통해 개인정보 처리방침의 변경사항을 안내할 수 있습니다.</p>

        <h3><strong>L. 문의</strong></h3>

        <p>귀하의 개인정보 이용 또는 관련 권리 행사에 관하여 추가 질문이나 요청이 있거나 추가 정보가 필요한 경우 support@akuvoxsmartplus.com 으로 연락할 수 있습니다. 귀하의 이름(또는 별칭), 선호하는 연락 방법, 요청 또는 의견의 세부사항 및 관련 웹 링크가 있는 경우 함께 제공해 주시기 바랍니다.</p>

        <p>개인정보 보호와 관련된 사항은 Akuvox의 개인정보 보호책임자(DPO)에게도 문의할 수 있습니다.</p>

        <p>이름: Tyler Zeng</p>

        <p>이메일: dpo@akuvox.com</p>
    </div>
</template>
<style lang="scss" scoped>
p {
    margin-top: 10px;
}
.policy-ul {
    padding-left: 20px;
    position: relative;

    li {
        list-style: disc;
    }
}

.policy {
    padding-bottom: 20px;
    p {
        text-align: justify;
    }

    li {
        text-align: justify;
    }
}
</style>
